var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",class:{ pcStyle: _vm.isPc, mobileStyle: _vm.isMobile }})
}
var staticRenderFns = []

export { render, staticRenderFns }